<form [formGroup]="form">
  <app-input-group>
    <label appLabel>{{ 'meteringpoint.meter.meternumber' | translate }}</label>
    <input type="text" appInput formControlName="meterNumber" readonly>
  </app-input-group>
  <app-input-group>
    <label appLabel>{{ 'meteringPoint.create.meteringPointSubType' | translate }}</label>
    <select appSelect [collection]="meterSubType" formControlName="subType">
    </select>
  </app-input-group>

  <app-input-group>
    <label appLabel>{{ 'common.changedate' | translate }}</label>
    <input appInputDate formControlName="validFrom">
  </app-input-group>

  @if (form.get('meteringPointCalculationStructure')?.enabled) {
    <app-calculation-form
      [form]="form"
      [rowHandler]="rowHandler"
    ></app-calculation-form>
  }
</form>
